// extracted by mini-css-extract-plugin
export default {"button":"PollMetaAnswer_button__djLww"};